import WebhookList from './List.vue'
import WebhookCreate from './Create.vue';
import WebhookView from './View.vue';
import AppContainer from '@/container/AppContainer.vue';

export const routes = [
    {
        path: '/webhooks',
        name: 'webhooks',
        component: AppContainer,
        children: [
            {
                path: 'new',
                component: WebhookCreate,
                meta: {
                    title: "New Webhook"
                }
            },
            {
                path: ':id',
                component: WebhookView,
                meta: {
                    title: "Webhook"
                }
            },
            {
                path: '/',
                component: WebhookList,
                meta: {
                    title: "Webhooks"
                }
            }
        ]
    }
]
